<template>
    <div class="form-elements">
        <div class="row" v-show="!download.load">
            <div class="col-md-6">
                <input type="month" id='mes-de-doacoes'><br>
                <span style=" font-size: 12px; color: #666; font-style: italic;">** No firefox utilizar o formato ano e mês ex.: xxxx-xx</span>
            </div>
            <div class="col-md-6">
                <button @click="getDoacoes()" class="btn btn-primary btn-micro">Gerar Relatório</button>
            </div>
        </div>
            <br><br>{{ erro }}
        <div v-show="download.load">
            <div class="d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <span>Pode demorar um pouco...</span>
            </div>
        </div>
        <a href="#" hidden id="downloadPDF"></a>
    </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../../../router/urlApi'

export default {
  name: 'relatorioDoacoes',
  components: {
    ...spinners,
  },
  data () {
    return {
      download: {
        load: false
      },
      erro: '',
    }
  },
  methods: {
    getDoacoes () {
      this.download.load = true
      this.erro = ''
      let mes = document.getElementById('mes-de-doacoes').value
      this.$http.get(urlApi + '/cfc/relatorio/doacoes-por-autoescola/' + mes)
        .then(this.downloadPDF)
        .catch(err => {
          console.error(err)
          this.download.load = false
          this.$toasted.show(err.data.mensagem, {
            position: 'top-right',
          })
        })
    },
    downloadPDF (response) {
      if (response.data.dados && response.data.dados != 'error') {
        let code64 = response.data.dados
        var pdf = 'data:application/octet-stream;base64,' + code64

        var dlnk = document.getElementById('downloadPDF')
        dlnk.download = 'doacoes-'+document.getElementById('mes-de-doacoes').value+'.pdf'
        dlnk.href = pdf
        dlnk.click()
        this.download.load = false
      } else if (response.data.dados == 'error') {
        this.$toasted.show(response.data.mensagem, {
          position: 'top-right',
        })
        this.erro = response.data.mensagem
        this.download.load = false
      } else {
        this.$toasted.show('Consulta não possui resultado', {
          position: 'top-right',
        })
        this.download.load = false
      }
    },
  },
}
</script>

<style>

</style>
